var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"amp",class:("amp--" + _vm.region),on:{"click":function($event){$event.preventDefault();return _vm.$emit('set-pref', _vm.pref)}}},[_vm._v("\n  "+_vm._s(_vm.pref.short_name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }